import { takeLatest, call, put, all, select } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, patchApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ResetarSenhaUsuarioMainframeRequest } from './types';

// ACTIONS
import {
	resetarSenhaUsuarioMainframeSuccess,
	resetarSenhaUsuarioMainframeFailure,
} from './actions';

function* resetarSenhaUsuarioMainframe(request: ReducerAction) {
	const { payload }: { payload: ResetarSenhaUsuarioMainframeRequest } = request;
	const { cpf, usuario } = payload;

	const token: string = yield select(state => state.user.token.data);

	const response: ApiResponse = yield call(
		patchApi,
		token,
		PATH_SGU_API,
		`usuarios-mainframe/${usuario}`,
		{},
		{ cpf },
	);

	if (response.status === 200) {
		yield put(resetarSenhaUsuarioMainframeSuccess(response));
	} else {
		yield put(resetarSenhaUsuarioMainframeFailure());
	}
}

export default all([
	takeLatest(
		Types.RESETAR_SENHA_USUARIO_MAINFRAME_REQUEST,
		resetarSenhaUsuarioMainframe,
	),
]);
